export const SECOND = 'second'
export const MINUTE = 'minute'
export const DAY = 'day'
export const WEEK = 'week'
export const MONTH = 'month'
export const QUARTER = 'quarter'
export const YEAR = 'year'
export const TIME = 'time'
export const DATE_TIME = 'datetime'

export const DURATION = 'duration'

export const DATE_TYPES = [DAY, MONTH, YEAR, TIME, DATE_TIME, DURATION]
